import React, { useState } from "react";
import { Card, Form, Row, Col, Image, Button } from "react-bootstrap";
import { useUploadFile } from "../../../../../../api/fileUpload/fileUpload.hooks";

const TourismAttractionsSection = ({ data, onUpdate }) => {
  const [isOpen, setIsOpen] = useState(true);
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onUpdate({ ...data, [field]: value });
  };

  const handleAttractionChange = (index, field, value) => {
    const updatedAttractions = [...data.attractions];
    updatedAttractions[index] = { ...updatedAttractions[index], [field]: value };
    handleChange("attractions", updatedAttractions);
  };

  const handleFileUpload = async (index, file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        handleAttractionChange(index, "image", res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  const addAttraction = () => {
    const newAttraction = { name: "", image: "", link: "" };
    handleChange("attractions", [...data.attractions, newAttraction]);
  };

  const removeAttraction = (index) => {
    const updatedAttractions = data.attractions.filter((_, i) => i !== index);
    handleChange("attractions", updatedAttractions);
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Tourism Attractions Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange('isVisible', e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  value={data.heading}
                  onChange={(e) => handleChange("heading", e.target.value)}
                  placeholder="Enter section heading"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={data.description}
                  onChange={(e) => handleChange("description", e.target.value)}
                  placeholder="Enter section description"
                />
              </Form.Group>
            </Col>
          </Row>

          <h6 className="mt-4 mb-3">Attractions</h6>
          {data.attractions.map((attraction, index) => (
            <div key={index} className="mb-4 p-3 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6>Attraction {index + 1}</h6>
                {data.attractions.length > 1 && (
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => removeAttraction(index)}
                  >
                    Remove
                  </Button>
                )}
              </div>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={attraction.name}
                      onChange={(e) => handleAttractionChange(index, "name", e.target.value)}
                      placeholder="Enter attraction name"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Link</Form.Label>
                    <Form.Control
                      type="url"
                      value={attraction.link}
                      onChange={(e) => handleAttractionChange(index, "link", e.target.value)}
                      placeholder="Enter attraction link"
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Image</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        e.target.files?.[0] && handleFileUpload(index, e.target.files[0])
                      }
                    />
                    {isUploading && (
                      <div className="text-muted small mt-1">
                        Uploading...
                      </div>
                    )}
                    {attraction.image && (
                      <div className="mt-2">
                        <Image
                          src={attraction.image}
                          alt="Preview"
                          thumbnail
                          style={{ maxWidth: "200px" }}
                        />
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </div>
          ))}
          <Button variant="outline-primary" onClick={addAttraction}>
            Add Attraction
          </Button>
        </Card.Body>
      )}
    </Card>
  );
};

export default TourismAttractionsSection;
